interface FontFaceProps {
    family: string;
    variant: string;
    weight: number;
    style: string;
    url: string;
}

export const createFontFace = ({
    family,
    variant,
    weight,
    style,
    url,
}: FontFaceProps) => `
    @font-face {
        font-family: '${family}';
        font-style: ${style};
        font-display: swap;
        font-weight: ${weight};
        src:
        local('☺︎'),
        local('${family}-${variant}'),
        url('${url}.woff2') format('woff2'),
        url('${url}.woff') format('woff');
        unicode-range: ${[
            'U+0000-00FF',
            'U+0131',
            'U+0152-0153',
            'U+02BB-02BC',
            'U+02C6',
            'U+02DA',
            'U+02DC',
            'U+2000-206F',
            'U+2074',
            'U+20AC',
            'U+2122',
            'U+2191',
            'U+2193',
            'U+2212',
            'U+2215',
            'U+FEFF',
        ].join(',')};
    }
`;

export const figtreeFontFaces: FontFaceProps[] = [
    {
        family: 'Figtree',
        variant: 'Regular',
        weight: 400,
        style: 'normal',
        url: '/_n/fonts/Figtree/Figtree-Regular',
    },
    {
        family: 'Figtree',
        variant: 'RegularItalic',
        weight: 400,
        style: 'italic',
        url: '/_n/fonts/Figtree/Figtree-Italic',
    },
    {
        family: 'Figtree',
        variant: 'Medium',
        weight: 500,
        style: 'normal',
        url: '/_n/fonts/Figtree/Figtree-Medium',
    },
    {
        family: 'Figtree',
        variant: 'MediumItalic',
        weight: 500,
        style: 'italic',
        url: '/_n/fonts/Figtree/Figtree-MediumItalic',
    },
    {
        family: 'Figtree',
        variant: 'SemiBold',
        weight: 600,
        style: 'normal',
        url: '/_n/fonts/Figtree/Figtree-SemiBold',
    },
    {
        family: 'Figtree',
        variant: 'SemiBoldItalic',
        weight: 600,
        style: 'italic',
        url: '/_n/fonts/Figtree/Figtree-SemiBoldItalic',
    },
];
